import { FC } from 'react';
import { Link, Menu } from '@chakra-ui/react';

import { Permissions } from '~/core/shared/generated/Permissions';
import { useUpToDateFileAttribute } from '~/core/shared/hooks';
import { useCan } from '~/core/shared/hooks/useCan';
import { useRescanFraudHandler } from './hooks';
import { FraudActionsMenuItemsProps } from './types';

export const FraudActionsMenuItems: FC<FraudActionsMenuItemsProps> = ({
  file,
  fraudUpdates,
  rescanFraud,
}) => {
  const { can } = useCan();
  const updatedFile = useUpToDateFileAttribute(file, fraudUpdates);

  const handleRescanClick = useRescanFraudHandler(rescanFraud, updatedFile?.id);

  if (!can(Permissions.DocsUpdate)) {
    return null;
  }

  return (
    <>
      {updatedFile?.fraudRisk?.analysisResult?.resultUrl && (
        <Menu.Item
          _hover={{ textDecoration: 'none' }}
          asChild
          value="view-fraud-analysis"
        >
          <Link
            href={updatedFile.fraudRisk.analysisResult.resultUrl}
            target="_blank"
          >
            View fraud analysis
          </Link>
        </Menu.Item>
      )}

      {updatedFile?.id && (
        <Menu.Item onClick={handleRescanClick} value="fraud-scan">
          Fraud scan
        </Menu.Item>
      )}
    </>
  );
};
